module.exports = __webpack_public_path__ + "static/grafika2-0a335da55d5c0b81979ceeaff75f7705.png";